import { createFileService } from '@workpay/ds-shared/services/fileService';
import { publicClient } from '@lib/axios';

export const fileService = createFileService(publicClient);
